/** Norwegian subscriber numbers are 8 digits — the only length we can safely prefix with +47. */
const NO_NUMBER_LENGTH = 8;

/**
 * Dial string for `href="tel:{…}"`, stripped of the spaces and punctuation RFC 3966 forbids.
 * The pretty number belongs in the link text. Norwegian 8-digit numbers get `+47`; country
 * codes and unrecognised lengths pass through untouched.
 *
 * Keep the `tel:` prefix literal at the call site — an expression href trips
 * `svelte/no-navigation-without-resolve`, which only understands router links.
 */
export const telDial = (phone: string): string => {
	const trimmed = phone.trim();
	const digits = trimmed.replace(/\D/g, "");

	if (!digits) return "";

	if (trimmed.startsWith("+")) return `+${digits}`;
	if (digits.startsWith("00")) return `+${digits.slice(2)}`;
	if (digits.length === NO_NUMBER_LENGTH) return `+47${digits}`;

	return digits;
};
